module.exports = __webpack_public_path__ + "img/text_5.fec2b5cc.png";